import React from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';
import BigImgScroll from '../../../common-components/big-img-scroll';

const Results = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="mts-invest-results">
                <CommonTitle className="mts-invest-results__title">Результаты</CommonTitle>
                <div className="mts-invest-results__items">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={50}
                        animateOnce={true}
                        duration={1}
                        className="mts-invest-results__item"
                    >
                        <div className="mts-invest-results__numbers">
                            <img
                                src="/images/svg/mts-invest/mts-invest-results__numbers1.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <CommonSmallText className="mts-invest-results__text">
                            Мы&nbsp;добились корректной индексации и&nbsp;увеличения в&nbsp;индексе
                            поисковых систем новых и&nbsp;целевых страниц на&nbsp;сайте
                            в&nbsp;2&nbsp;раза.
                        </CommonSmallText>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={50}
                        animateOnce={true}
                        duration={1}
                        className="mts-invest-results__item"
                    >
                        <div className="mts-invest-results__numbers">
                            <img
                                src="/images/svg/mts-invest/mts-invest-results__numbers2.svg"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                        <CommonSmallText className="mts-invest-results__text">
                            В&nbsp;4&nbsp;раза увеличили показатель роста трафика на&nbsp;блог
                            в&nbsp;результате комплексной и&nbsp;командной работы
                            с&nbsp;делегированием текстов на&nbsp;сторону клиента.
                        </CommonSmallText>
                    </ScrollAnimation>
                </div>
                <ScrollAnimation
                    animateIn="fadeInUp"
                    offset={50}
                    animateOnce={true}
                    duration={1}
                    className="mts-invest-results__img-wrapper"
                >
                    <BigImgScroll img="/images/pic/mts-invest/mts-invest-results__img.png" />
                </ScrollAnimation>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Results;
